import { AboutContext } from "../context/AboutContext";
import { useContext } from "react";

export const useAboutContext = () => {
    const context = useContext(AboutContext);

    if (!context) {
        return Error('useAboutContext must be used inside an AboutContextProvider');
    };

    return context;
};